<template>
    <div class="row p-4">
        <label for="new_markup_name" class="form-label">Project Name</label>
        <input type="text" name="name" id="new_markup_name" class=" form-control mb-4" v-model="form.name">
        <!-- <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" @change="show = !show" checked>
            <label class="form-check-label" for="flexSwitchCheckChecked">Link a Risk Assessment</label>
        </div> -->

        <label class="form-label" for="search_markers">Find a Risk Assessment</label>
        <input
            class="form-control"
            type="search"
            id="search_markers"
            v-model="form.search"
            placeholder="Search Risk Assessments"
            aria-label="Search Risk Assessments"
            @blur="fetchSearch"
            @input="fetchSearch"
        >
        <div class="row mt-4 p-2 mx-auto scroll-window">
            <div class="d-flex align-items-center mb-1 p-2 border rounded justify-content-between" v-for="result in results" :key="result.id" @click="select(result)">
                <div class="d-flex align-items-center">
                    <!-- <img :src="result?.image?.url" alt="" class="img me-4" width="32"> -->
                    {{ result?.title }}
                </div>
                <!-- <button  class="btn btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </button> -->
            </div>
        </div>

        <div class="d-flex align-items-center mt-2" v-if="selected">
            <!-- <img :src="selected?.image?.url" alt="" class="img me-4" width="32"> -->
            {{ selected?.title }}
        </div>

        <input hidden type="text" name="risk" id="new_markup_risk" class="mb-4" v-model="form.risk">
    </div>
</template>

<script>
    import axios from 'axios';
    import throttle from 'lodash/throttle'

    export default {
        props: ['element', 'listener'],
        emits: ['updated:results', 'canceled'],
        data() {
            return {
                show: true,
                results: [],
                selected: null,
                form: {
                    search: null,
                    name: null,
                    risk: null,
                }
            }
        },
        methods: {
            select(result) {
                this.form.risk = result.ulid
                this.selected = result
                this.form.search = null;
                this.results = []
            },
             fetchSearch: throttle(function () {
                axios.get(`/risk/search?query=${this.form.search}`)
                    .then(response => {
                        if (response.status == 200) {
                            this.results = response.data.data?.flat() ?? []
                        }
                        this.$emit('update:results', this.results)
                    })
                    .catch(error => {
                        console.error(error)
                        this.$emit('update:results', this.results)
                    })
            }, 500, { trailing: true }),
        },
    }
</script>

<style scoped>
    .scroll-window {
        max-height: 300px;
        overflow: scroll;
    }
</style>
